import { orderBy } from "lodash";
import {
  RacePool,
  BettingInterestPool,
  PoolRunnerData
} from "@tvg/ts-types/Race";
import { formatCurrencyShortened } from "@tvg/formatter/currency";
import { mathPercentageFormatted } from "@tvg/utils/mathUtils";

export const getOrderedRacePools = (
  racePools: RacePool[] | null,
  wagerTypeLimit: number,
  exoticNPicks: boolean
) =>
  orderBy(
    racePools?.filter((pool: RacePool) =>
      exoticNPicks
        ? pool.wagerType.id > wagerTypeLimit
        : pool.wagerType.id <= wagerTypeLimit
    ),
    ["wagerType.id"],
    ["asc"]
  );

export const getPoolAmountPercentage = (
  poolRunnerAmount: number,
  racePoolAmount: number
) => {
  const percentage =
    Math.round(((poolRunnerAmount * 100) / racePoolAmount) * 10) / 10;
  if (Number.isNaN(percentage)) {
    return 0;
  }
  return percentage;
};

export const getPools = (
  racePools: RacePool[] | null,
  biPools: BettingInterestPool[] | undefined | null,
  wagerTypeLimit: number,
  currentUnit: string
) => {
  const racePoolsOrdered = getOrderedRacePools(
    racePools,
    wagerTypeLimit,
    false
  );
  return racePoolsOrdered.map((racePool: RacePool) => {
    let pool = biPools?.find(
      (biPool) => biPool.wagerType.id === racePool.wagerType.id
    );

    // Display the "amount" according to the unit selected
    if (pool && currentUnit === "percentage") {
      pool = {
        ...pool,
        poolRunnersData: [
          {
            amount: Math.round(
              +mathPercentageFormatted(
                racePool.amount,
                pool.poolRunnersData[0]?.amount || 0,
                1
              ).replace(/%/g, "")
            )
          }
        ]
      };
    }

    return (
      pool || {
        wagerType: racePool.wagerType,
        poolRunnersData: []
      }
    );
  });
};

export const getPoolRunnersDataAmount = (
  biScratched: boolean,
  poolRunnersData: PoolRunnerData[],
  currentUnit: string
) => {
  const poolRunnersDataAmount = poolRunnersData[0]?.amount || 0;
  if (biScratched || !poolRunnersData.length) {
    return "-";
  }

  if (currentUnit === "USD") {
    return formatCurrencyShortened(poolRunnersDataAmount);
  }

  return `${poolRunnersDataAmount}%`;
};
